<template>
  <b-container>
    <div class="b-main-content">
      <h2>Database builder</h2>
      <DbCompile></DbCompile>
    </div>
  </b-container>
</template>

<script>

import { mapState } from 'vuex'
import DbCompile  from '../components/db-compile/SecureDeploy'
import store from "@/store"
import router from "@/router"

export default {
  components: {
    DbCompile
  }
}
</script>
